import { render, staticRenderFns } from "./SenderNameExamplePreview.vue?vue&type=template&id=68bfb856&"
import script from "./SenderNameExamplePreview.vue?vue&type=script&lang=js&"
export * from "./SenderNameExamplePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports